import Image from 'next/image';
import React, { useEffect, useState } from 'react';

const PcModelPanelPrintsImagesView = ({ panelPrintImages, sku }) => {
  const images = panelPrintImages.data.body.filter(
    (imagesObj) => imagesObj.primary.panel_print_sku === sku,
  )[0]?.items;

  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [transitionClass, setTransitionClass] = useState('');

  useEffect(() => {
    setSelectedImageIndex(0); // Reset to the first image when SKU changes
  }, [sku]);

  const handleSelectImage = (index) => {
    if (index > selectedImageIndex) {
      setTransitionClass('slide-out-left');
      setTimeout(() => {
        setSelectedImageIndex(index);
        setTransitionClass('slide-in-right');
      }, 100);
    } else if (index < selectedImageIndex) {
      setTransitionClass('slide-out-right');
      setTimeout(() => {
        setSelectedImageIndex(index);
        setTransitionClass('slide-in-left');
      }, 100);
    }
  };

  const handlePrevImage = () => {
    setTransitionClass('slide-out-right');
    setTimeout(() => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === 0 ? images.length - 1 : prevIndex - 1,
      );
      setTransitionClass('slide-in-left');
    }, 100);
  };

  const handleNextImage = () => {
    setTransitionClass('slide-out-left');
    setTimeout(() => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1,
      );
      setTransitionClass('slide-in-right');
    }, 100);
  };

  return (
    <>
      <div className="panel-prints-images-view-wrapper">
        {!images || images.length === 0 ? (
          <p>No images available for this SKU</p>
        ) : (
          <>
            <div className={`panel-prints-active-image ${transitionClass}`}>
              <Image
                src={images[selectedImageIndex]?.panel_print_image?.url}
                layout="fill"
                objectFit="contain"
                alt={
                  images[selectedImageIndex]?.panel_print_image.alt
                    ? images[selectedImageIndex]?.panel_print_image.alt
                    : 'Panel Print'
                }
              />
            </div>
            <div className="panel-prints-images-carousel-wrapper">
              <div className="carousel-arrow" onClick={handlePrevImage}>
                <Image
                  src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Arrow_2.png?v=1723822490"
                  width={10}
                  height={20}
                  alt="Previous"
                />
              </div>
              <div className="panel-prints-images-carousel">
                {images.map((image, index) => (
                  <div
                    key={index}
                    className={`panel-prints-image ${
                      selectedImageIndex === index ? 'active-image' : ''
                    }`}
                    onClick={() => handleSelectImage(index)}
                  >
                    <Image
                      src={image.panel_print_image.url}
                      layout="fill"
                      objectFit="contain"
                      alt={
                        image.panel_print_image.alt
                          ? image.panel_print_image.alt
                          : `Thumbnail ${index + 1}`
                      }
                    />
                  </div>
                ))}
              </div>
              <div className="carousel-arrow" onClick={handleNextImage}>
                <Image
                  src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/Arrow_1.png?v=1723822490"
                  width={10}
                  height={20}
                  alt="Next"
                />
              </div>
            </div>
          </>
        )}
      </div>
      <style jsx>{`
        .panel-prints-images-view-wrapper {
          position: sticky;
          top: 200px;
          left: 0;
          width: 60%;
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 5px;
          overflow: hidden;
        }
        .panel-prints-active-image {
          position: relative;
          width: 700px;
          height: 700px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition:
            transform 0.3s ease-in-out,
            opacity 0.3s ease-in-out;
        }
        .slide-out-left {
          transform: translateX(-100%);
          opacity: 0;
        }
        .slide-out-right {
          transform: translateX(100%);
          opacity: 0;
        }
        .slide-in-left {
          transform: translateX(-100%);
          opacity: 0;
          animation: slideInFromLeft 0.3s forwards;
        }
        .slide-in-right {
          transform: translateX(100%);
          opacity: 0;
          animation: slideInFromRight 0.3s forwards;
        }
        @keyframes slideInFromLeft {
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes slideInFromRight {
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        .panel-prints-images-carousel-wrapper {
          width: 100%;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          padding: 0 20px;
        }
        .panel-prints-images-carousel {
          width: 700px;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 10px;
        }
        .panel-prints-image {
          position: relative;
          width: 100px;
          height: 100px;
          border: 1px solid transparent;
          cursor: pointer;
          transition: transform 0.3s ease-in-out;
          border-radius: 5px;
          overflow: hidden;
          background-color: #303030;
        }
        .active-image {
          border: 1.5px solid #fd0300;
        }
        .carousel-arrow {
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        @media (max-width: 900px) {
          .panel-prints-images-view-wrapper {
            width: 100%;
            top: 0;
            gap: 20px;
            position: relative;
            padding: 20px;
          }
          .panel-prints-active-image {
            width: 100%;
            height: 300px;
          }
          .panel-prints-images-carousel {
            width: 100%;
            height: auto;
            flex-wrap: wrap;
          }
          .panel-prints-image {
            width: 80px;
            height: 80px;
          }
        }
        @media (max-width: 430px) {
          .panel-prints-images-view-wrapper {
            width: 100%;
            top: 0;
            position: relative;
            padding: 0 30px;
            gap: 20px;
          }
          .panel-prints-active-image {
            width: 100%;
            height: 300px;
          }
          .panel-prints-images-carousel {
            width: 100%;
            height: auto;
          }
          .panel-prints-image {
            width: 50px;
            height: 50px;
          }
        }
      `}</style>
    </>
  );
};

export default PcModelPanelPrintsImagesView;
